<script>
import broker from '../../utils/broker';

import Header from '../../components/header-top-fix-green';
import BreadCrumb from '../../components/bread-crumb-green';
import ContentSejarah from '../../components/content-sejarah-green';
import Footer from '../../components/footer-green';
import OffCanvasMobileMenu from '@/components/off-canvas-mobile-menu-green';

import data from '../../data/slider.json';
export default {
  props: ['dataMeta'],
  data() {
    return {
      history: {},
      items: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Sejarah',
          active: true,
        },
      ],
    };
  },
  components: {
    Header,
    BreadCrumb,
    ContentSejarah,
    Footer,
    OffCanvasMobileMenu,
  },
  metaInfo() {
    return {
      title: `${this.dataMeta.name} - Sejarah`,
      htmlAttrs: {
        lang: 'en',
        amp: true,
      },
    };
  },
  mounted() {
    broker.fetch
      .get(`/webschool/content?types[]=history&status=published`)
      .then((res) => {
        const data = res.data.data;
        this.history = data.find((o) => o.type.name === 'history');
      });
  },
};
</script>
<template>
  <div class="main-container">
    <Header :meta="dataMeta" />

    <!-- <BreadCrumb :items="items" title="Sejarah" /> -->

    <ContentSejarah :data="history" />

    <Footer bgFooter="old-blue-bg" :meta="dataMeta" />

    <OffCanvasMobileMenu :meta="dataMeta" />

    <!-- back to top start -->
    <back-to-top class="scroll-top-green" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>
